<div class="search-bar">
  <mat-form-field appearance="outline">
    <mat-label>Buscar trabajador, empresa...</mat-label>
    <mat-icon matTextPrefix style="position: relative; top: +0.33em">search</mat-icon>
    <input matInput type="search" [formControl]="filterControl" />
  </mat-form-field>
  <div class="paginator-container">
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons class="paginator-field"></mat-paginator>
  </div>
</div>
<table mat-table [dataSource]="dataSource">
  <!-- Employee ID Column -->
  <ng-container matColumnDef="employee_id">
    <th mat-header-cell *matHeaderCellDef>ID CONDUCTOR</th>
    <td mat-cell *matCellDef="let element" [class.no-vacation-data]="
        (isDriverResponse(element) &&
          !element.status_info.has_pending_requests) ||
        (isPetitionResponse(element) &&
          (!element.requests || element.requests.length === 0))
      ">
      @if (isDriverAssignment(element)) {
      <!-- For DriverAssignment, show driver ID -->
      <div class="employee">
        {{ element.driver.toString().padStart(5, "0") }}
      </div>
      } @else if ((isPetitionResponse(element) && element.requests &&
      element.requests.length > 0) || (isDriverResponse(element) &&
      element.status_info.has_pending_requests)) {
      <div class="employee">
        <mat-icon>error</mat-icon>
        {{ element.employee.first_name }}
      </div>
      } @else {
      {{ element.employee.first_name }}
      }
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>NOMBRE</th>
    <td mat-cell *matCellDef="let element" [class.no-vacation-data]="
        (isDriverResponse(element) &&
          !element.status_info.has_pending_requests) ||
        (isPetitionResponse(element) &&
          (!element.requests || element.requests.length === 0))
      ">
      @if (isDriverAssignment(element)) {
      <!-- For DriverAssignment, we don't have name yet -->
      <div class="employee">
        {{ element.driver }}
        <!-- .toString().padStart(5, "0") | qeqPipe  -->
      </div>
      } @else {
      {{ element.employee.full_name | qeqPipe }}
      }
    </td>
  </ng-container>

  <!-- Company Column -->
  <ng-container matColumnDef="company">
    <th mat-header-cell *matHeaderCellDef>EMPRESA</th>
    <td mat-cell *matCellDef="let element" [class.no-vacation-data]="
        (isDriverResponse(element) &&
          !element.status_info.has_pending_requests) ||
        (isPetitionResponse(element) &&
          (!element.requests || element.requests.length === 0))
      ">
      @if (isDriverAssignment(element)) {
      <!-- For DriverAssignment, we don't have company yet -->
      <span class="text-muted">-</span>
      } @else {
      {{ element.employee.company }}
      }
    </td>
  </ng-container>

  <!-- Age Column -->
  <ng-container matColumnDef="age">
    <th mat-header-cell *matHeaderCellDef>ANTIGÜEDAD</th>
    <td mat-cell *matCellDef="let element" [class.no-vacation-data]="
        (isDriverResponse(element) &&
          !element.status_info.has_pending_requests) ||
        (isPetitionResponse(element) &&
          (!element.requests || element.requests.length === 0))
      ">
      @if (isDriverAssignment(element)) {
      <!-- For DriverAssignment, show assigned date -->
      <div class="age">
        {{ element.assigned_date }}
        <div class="started"></div>
      </div>
      } @else {
      <div class="age">
        {{ element.employee.seniority_display }}
        <div class="started">
          {{ element.employee.join_date }}
        </div>
      </div>
      }
    </td>
  </ng-container>

  <!-- Status Column -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>ESTADO</th>
    <td mat-cell *matCellDef="let element" [class.no-vacation-data]="
        (isDriverResponse(element) &&
          !element.status_info.has_pending_requests) ||
        (isPetitionResponse(element) &&
          (!element.requests || element.requests.length === 0))
      ">
      @if (isDriverAssignment(element)) {
      <!-- For DriverAssignment, show status badge -->
      @if(element.status === 'active'){
      <button mat-flat-button id="consumed">
        <mat-icon matTextPrefix>check_circle</mat-icon>
        <span style="font-size: 16px">Activo</span>
      </button>
      }@else if (element.status === 'inactive') {
      <button mat-flat-button id="non-consumed">
        <mat-icon matTextPrefix>cancel</mat-icon>
        <span style="font-size: 16px">Inactivo</span>
      </button>
      }@else if (element.status === 'transferred') {
      <button mat-flat-button id="reservation">
        <mat-icon matTextPrefix svgIcon="pending"></mat-icon>
        <span style="font-size: 16px">Transferido</span>
      </button>
      }
      } @else if (isDriverResponse(element) || isPetitionResponse(element)) {
      @if(element.status_info.employee_status === 'active'){
      <button mat-flat-button id="consumed">
        <mat-icon matTextPrefix>check_circle</mat-icon>
        <span style="font-size: 16px">Alta</span>
      </button>
      }@else {
      <button mat-flat-button id="non-consumed">
        <mat-icon matTextPrefix>cancel</mat-icon>
        <span style="font-size: 16px">Baja</span>
      </button>
      }
      }
    </td>
  </ng-container>

  <!-- Vacation Days Column -->
  <ng-container matColumnDef="vacation_days">
    <th mat-header-cell *matHeaderCellDef>DÍAS DE VACACIONES</th>
    <td mat-cell *matCellDef="let element" [class.no-vacation-data]="
        (isDriverResponse(element) &&
          !element.status_info.has_pending_requests) ||
        (isPetitionResponse(element) &&
          (!element.requests || element.requests.length === 0))
      ">
      <!-- For DriverAssignment, no vacation data available yet -->
      @if (isDriverAssignment(element)) {
      <div class="vacation-dates">
        <span class="text-muted">Sin datos de vacaciones</span>
      </div>
      }

      <!-- For PetitionResponse with requests -->
      @if (isPetitionResponse(element) && element.requests &&
      element.requests.length > 0) { @for (request of element.requests; track
      request.id) {
      <div class="vacation-pending petition" [class.collapsed]="!onlyPetitions() && !expandedHas(element)">
        <span>
          <mat-icon>error</mat-icon> {{ request.message }}
          @if (!onlyPetitions()) {
          <div class="vacation-buttons">
            <button mat-icon-button (click)="toggleRow(element)">
              <mat-icon style="color: #2d3872">
                {{ expandedHas(element) ? "expand_less" : "expand_more" }}
              </mat-icon>
            </button>
          </div>
          }
        </span>
        @if (!onlyPetitions() && expandedHas(element) || onlyPetitions()) {
        <div class="extra-detail">
          @if (request.weeks && request.weeks.length > 0) {
            @for (week of request.weeks; track week.week_number) {
              <div class="vacation-dates">
                {{ week.start_date }} - {{ week.end_date }}
              </div>
            }
          } @else {
            <div class="vacation-dates">
              {{ request.start_date }} - {{ request.end_date }}
            </div>
          }
          <div class="vacation-buttons">
            @if (request.can_approve) {
            <button mat-flat-button id="action" (click)="onApproveRequest(request.uuid)">
              Aprobar petición
            </button>
            } @if (request.can_deny) {
            <button mat-flat-button id="delete" (click)="onDenyRequest(request.uuid)">
              Denegar
            </button>
            }
          </div>
        </div>
        }
      </div>
      } }

      <!-- For DriverResponse with pending requests -->
      @if (isDriverResponse(element) && element.status_info.has_pending_requests) {
      <div class="vacation-pending" [class.collapsed]="!onlyPetitions() && !expandedHas(element)">
        <span>
          <mat-icon>error</mat-icon>
          Tiene {{ element.vacation_summary.pending_approval_days }} días pendientes de aprobación
          @if (!onlyPetitions() && element.actions?.toggle_enabled) {
          <div class="vacation-buttons">
            <button mat-icon-button (click)="toggleRow(element)">
              <mat-icon style="color: #2d3872">
                {{ expandedHas(element) ? "expand_less" : "expand_more" }}
              </mat-icon>
            </button>
          </div>
          }
        </span>
      </div>
      }

      <!-- Vacation summary - only shown when NOT in onlyPetitions mode -->
      @if (isPetitionResponse(element) && !onlyPetitions()) { @if (!element.requests ||
      element.requests.length === 0 || expandedHas(element)) {
      <div class="vacation-dates">
        Ha usado
        <strong>{{ element.vacation_summary.total_days_used }}</strong> de
        <strong>{{ element.vacation_summary.total_days_entitled }}</strong> días
        totales (<strong>{{
          element.vacation_summary.total_days_remaining
          }}</strong>
        restantes)
      </div>
      } @if (element.requests && element.requests.length > 0 &&
      element.vacation_summary.pending_to_take && expandedHas(element)) {
      <div class="vacation-dates">
        {{ element.vacation_summary.pending_to_take }}
      </div>
      } @if (!element.requests || element.requests.length === 0 ||
      expandedHas(element)) {
      <div class="vacation-dates last">
        {{ element.vacation_summary.personal_days_available_display }}
      </div>
      } }

      <!-- For DriverResponse -->
      @if (isDriverResponse(element)) { @if
      (!element.status_info.has_pending_requests || onlyPetitions() ||
      (!onlyPetitions() && expandedHas(element))) {
      <div class="vacation-dates">
        Ha usado
        <strong>{{ element.vacation_summary.total_days_used }}</strong> de
        <strong>{{ element.vacation_summary.total_days_entitled }}</strong> días
        totales (<strong>{{
          element.vacation_summary.total_days_remaining
          }}</strong>
        restantes)
      </div>
      } @if (element.status_info.has_pending_requests &&
      element.vacation_summary.days_pending_to_take > 0 && (onlyPetitions()
      || (!onlyPetitions() && expandedHas(element)))) {
      <!-- <div class="vacation-dates">
        Quedan por disfrutar
        <strong>{{ element.vacation_summary.days_pending_to_take }}</strong> días
      </div> -->
      } @if (!element.status_info.has_pending_requests || onlyPetitions() ||
      (!onlyPetitions() && expandedHas(element))) {
      <div class="vacation-dates last">
        Días personales
        <strong>{{ element.vacation_summary.personal_days_available || 0 }}</strong> disponibles,
        <strong>{{ element.vacation_summary.personal_days_used }}</strong> usados
      </div>
      } }
    </td>
  </ng-container>

  <!-- Actions Column -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element" [class.no-vacation-data]="
        (isDriverResponse(element) &&
          !element.status_info.has_pending_requests) ||
        (isPetitionResponse(element) &&
          (!element.requests || element.requests.length === 0))
      ">
      @if (isDriverAssignment(element)) {
      <!-- For DriverAssignment, show basic actions -->
      <button mat-icon-button (click)="onDriverAssignmentClick(element)">
        <mat-icon mat-icon-button style="color: #2d3872">info_outline</mat-icon>
      </button>
      } @else if (isDriverResponse(element)) {
      <!-- For DriverResponse from getOperativeDrivers -->
      <button mat-icon-button (click)="onDriverProfileClick(element)">
        <mat-icon mat-icon-button style="color: #2d3872">info_outline</mat-icon>
      </button>
      @if (element.actions?.can_edit) {
      <button mat-icon-button>
        <mat-icon mat-icon-button svgIcon="edit"></mat-icon>
      </button>
      } @if (element.actions?.can_delete) {
      <button mat-icon-button>
        <mat-icon mat-icon-button svgIcon="delete"></mat-icon>
      </button>
      } } @else {
      <!-- Botones de peticiones pendientes -->
      <button mat-icon-button (click)="onPetitionProfileClick(element)">
        <mat-icon mat-icon-button style="color: #2d3872">info_outline</mat-icon>
      </button>

      <!-- <button mat-icon-button>
          <mat-icon mat-icon-button svgIcon="edit"></mat-icon>
        </button>

        <button mat-icon-button>
          <mat-icon mat-icon-button svgIcon="delete"></mat-icon>
        </button> -->
      }
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

@if (dataSource.data.length === 0) {
<div style="padding: 20px; text-align: center;">
  @if (onlyPetitions()) {
  <p>No hay peticiones pendientes</p>
  } @else {
  <p>No hay conductores asignados</p>
  }
</div>
}